import { render, staticRenderFns } from "./DevByKimsa.vue?vue&type=template&id=7ee9fbf2&scoped=true&"
import script from "./DevByKimsa.vue?vue&type=script&lang=js&"
export * from "./DevByKimsa.vue?vue&type=script&lang=js&"
import style0 from "./DevByKimsa.vue?vue&type=style&index=0&id=7ee9fbf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee9fbf2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
